import { IFloorDetails, IPortfolioRegion } from '@api'
import { LocationNodeType } from './renderTreeContents'
import getFavoriteFloorsFromRegions from './getFavoriteFloorsFromRegions'

const mapFavoriteTreeContents = (
  regions: IPortfolioRegion[],
  paramsFloorId: string,
  favoriteFloors: string[]
) => {
  const floors = getFavoriteFloorsFromRegions(regions, favoriteFloors)

  return [
    {
      id: 'my favorites',
      label: 'My Favorites',
      isExpanded: false,
      isSelected: false,
      nodeData: {
        nodeType: LocationNodeType.Location,
      },
      childNodes: mapFavoriteFloorNodes(floors, paramsFloorId),
    },
  ]
}

export default mapFavoriteTreeContents

export const mapFavoriteFloorNodes = (floors: IFloorDetails[], paramsFloorId: string) =>
  floors.map((floor) => ({
    id: floor.id,
    hasCaret: false,
    label: `${floor.building.name} - ${floor.name}`,
    isExpanded: false,
    isSelected: paramsFloorId === floor.id,
    nodeData: {
      floor,
      nodeType: LocationNodeType.Floor,
    },
  }))
